// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blink_me[data-v-04372058] {\n  -webkit-animation: blinker-data-v-04372058 5s infinite;\n          animation: blinker-data-v-04372058 5s infinite;\n}\n@-webkit-keyframes blinker-data-v-04372058 {\n0% {\n    color: red;\n}\n50% {\n    color: #9c377b;\n}\n100% {\n    color: red;\n}\n}\n@keyframes blinker-data-v-04372058 {\n0% {\n    color: red;\n}\n50% {\n    color: #9c377b;\n}\n100% {\n    color: red;\n}\n}\n", ""]);
// Exports
module.exports = exports;
